import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

export const useRemoveNotiflow = (
  projectId: string,
  notiflowId: string,
  options: Omit<UseMutationOptions<void, ErrorResponse, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<void> => {
      await api.delete(`/projects/${projectId}/notiflows/${notiflowId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "notiflows", notiflowId],
      });
    },
    ...options
  });
};
